import React, {Component} from "react";
import {Form, Switch, Input, InputNumber} from 'antd';
import NHFormItem from '../../../common/NHFormItem/index';
import PropTypes from 'prop-types';

const {TextArea} = Input;
const now = new Date();
const year = now.getFullYear();

/**
 * 步骤一配置流程信息
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-08 10:34:00
 * Version: 1.0
 * Modify log:
 */
class FirstStep extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {form, initFormData} = this.props;
        return (
            <div>
                <Form layout="horizontal">
                    <NHFormItem id={'lcmc'} label={'流程名称'} hasFeedback={true} form={form} required={true} whitespace={true}
                                pattern={{max: 100, message: "流程名称长度不能超过100字符！"}}
                                initialValue={initFormData.lcmc}>
                        <Input placeholder="请输入流程名称"/>
                    </NHFormItem>
                    <NHFormItem id={'nd'} label={'年度'} hasFeedback={true} form={form} required={true}
                                initialValue={initFormData.nd ? initFormData.nd : year}>
                        <InputNumber/>
                    </NHFormItem>
                    <NHFormItem id={'lcsm'} label={'流程说明'} hasFeedback={true} form={form}
                                pattern={{max: 100, message: "流程说明长度不能超过100字符！"}}
                                initialValue={initFormData.lcsm}>
                        <TextArea placeholder="请输入100字以内的流程说明"/>
                    </NHFormItem>
                    <NHFormItem id={'pxh'} label={'排序号'} hasFeedback={true} form={form}
                                initialValue={initFormData.pxh ? initFormData.pxh : 1}>
                        <InputNumber min={0} max={999999}/>
                    </NHFormItem>
                    <NHFormItem id={'zt'} label={'流程状态'} form={form} valuePropName={'checked'}
                                valuePropName={'checked'}
                                initialValue={initFormData.zt?(initFormData.zt == '1'?true:false):true}>
                        <Switch checkedChildren="启用" unCheckedChildren="停用"/>
                    </NHFormItem>
                </Form>
            </div>
        )
    }
}

FirstStep.defaultProps = {
    initFormData: {} //初始表单数据
}

FirstStep.propTypes = {
    initFormData: PropTypes.object //初始表单数据
}

const firstStep = Form.create({onValuesChange(props, values){props.onChange(values);}})(FirstStep);
export default firstStep;


// WEBPACK FOOTER //
// ./components/lcgl/lcpz/edit-form/step-first.js